export const socketEvents = {
  chatroom: {
    members: {
      created: 'chatrooms/:id/members created',
      removed: 'chatrooms/:id/members removed',
    },
    messages: {
      created: 'chatrooms/:chatroomId/messages created',
    },
    removed: 'chatrooms removed',
  },
};
